import React from 'react'
import cn from 'classnames'
import styles from './Callout.module.sass'
import ScrollParallax from '../../ScrollParallax'

export const Callout = () => {
  const launchChat = () => {
    // @ts-ignore
    // window.$crisp.push(['do', 'chat:open'])
    // window.$crisp.push(['do', 'message:send', ['text', "Hi! I'd like to book a demo"]])
  }

  return (
    <div className={styles.callout}>
      <div className={cn('container', styles.container)}>
        <ScrollParallax className={styles.preview} animateIn="fadeInUp">
          <div className={styles.wrap}>
            <h2 className={cn('h2', styles.title)}>Connect your team with the Guardians</h2>
            <div className={styles.info}>
              Help your developers to deliver better software faster! 🚀
            </div>
            <div className={styles.btns}>
              <a onClick={() => launchChat()} className={cn('button', styles.button)}>
                Ask for a demo
              </a>
            </div>
          </div>
        </ScrollParallax>
      </div>
    </div>
  )
}

export default Callout
